






import { Component, Vue, Prop } from 'vue-property-decorator'
import { ElementUIComponentSize } from 'element-ui/types/component'

@Component
export default class Button extends Vue {
  @Prop()
  type?: string

  @Prop({
    default: 'small'
  })
  size?: boolean

  @Prop()
  url?: string // 新窗口打开地址

  @Prop()
  message?: string // 复制文本

  @Prop()
  success?: Function // 复制文本成功

  @Prop()
  error?: Function // 复制文本失败

  get props () {
    return Object.assign({}, this.$props, this.$attrs)
  }

  handleClick () {
    if (this.url) {
      return window.open(this.url)
    }

    if (this.message) {
      return this.$copyText(this.message || '').then(this.onCopySuccess, this.onCopyError)
    }

    this.$emit('click')
  }

  onCopySuccess () {
    if (this.success) {
      this.success()
    } else {
      this.$message.success('复制成功')
    }
  }

  onCopyError () {
    if (this.error) {
      this.error()
    } else {
      this.$message.error('复制失败')
    }
  }
}
